export const WEBHOOK = 'webhook'
